import { apiClient } from '../apiClient';

export interface Achievement {
  key: string;
  title: string;
  description: string;
  unlocked_at: string;
}

export const achievementsApi = {
  list: () => apiClient.get<Achievement[]>('/api/v1/achievements'),
};
